import constants from '@/constants';
export default constants.TEXT_CONTROLS;
